<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const emit = defineEmits(['subscribed'])

const { lazy = true } = defineProps<{
  lazy?: boolean
}>()

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { newsletterSubscription } = useDataLayer()
const { email, confirmed, confirm, subscribe, subscribeToNewsletterLoading } = useNewsletter()

const subscribeToNewsletter = async () => {
  subscribe.value = true
  const result = await confirm()

  if (result) { // success ?
    newsletterSubscription(email.value)
    emit('subscribed')
  }
}
</script>

<template>
  <div
    class="newsletter"
  >
    
<FormKitLazyProvider>
<picture
      v-if="layoutData?.newsletter?.Image"
      class="newsletter__picture"
    >
      <source
        :srcset="useXcdnImage(layoutData.newsletter.Image?.url, 'f=rs:fit:2560')"
        media="(min-width: 1280px)"
      >
      <source
        :srcset="useXcdnImage(layoutData.newsletter.Image?.url, 'f=rs:fit:1280')"
        media="(min-width: 1024px)"
      >
      <source
        :srcset="useXcdnImage(layoutData.newsletter.Image?.url, 'f=rs:fit:1024')"
        media="(min-width: 768px)"
      >
      <source
        :srcset="useXcdnImage(layoutData.newsletter.ImageMobile?.url || layoutData.newsletter.Image?.url, 'f=rs:fit:768')"
        media="(min-width: 640px)"
      >
      <source
        :srcset="useXcdnImage(layoutData.newsletter.ImageMobile?.url || layoutData.newsletter.Image?.url, 'f=rs:fit:640')"
      >
      <img
        class="newsletter__image"
        :src="useXcdnImage(layoutData.newsletter.Image?.url, 'f=rs:fit:2560')"
        :alt="layoutData.newsletter.Image?.alternativeText || ''"
        :width="layoutData.newsletter.Image?.width"
        :height="layoutData.newsletter.Image?.height"
        :loading="lazy ? 'lazy' : 'eager'"
        :fetchpriority="lazy ? 'low' : 'high'"
        :decoding="lazy ? 'async' : 'sync'"
      >
    </picture>

    <div class="newsletter__container">
      <div class="newsletter__heading">
        {{ layoutData?.newsletter?.Title || $t('Be inspired') }}
      </div>

      <p class="newsletter__description">
        {{ layoutData?.newsletter?.Description || $t('Receive the best offers and personal advice.') }}
      </p>

      <template v-if="!confirmed">
        <FormKit
          id="newsletter__form"
          name="newsletter__form"
          type="form"
          :incomplete-message="$t('Sorry, not all fields are filled out correctly.')"
          form-class="newsletter__form"
          :actions="false"
          @submit="subscribeToNewsletter"
        >
          <FormKit
            id="newsletter__email"
            v-model="email"
            type="email"
            name="email"
            :label="$t('Email address') + ' *'"
            :placeholder="$t('Email address')"
            :disabled="subscribeToNewsletterLoading || confirmed"
            validation="required|email"
            :validation-label="$t('Email address')"
          />

          <FormKitMessages hidden />

          <button
            type="submit"
            class="newsletter__button"
          >
            <span>{{ $t('Subscribe') }}</span>
            <NuxtIcon name="icon:arrow" />
          </button>
        </FormKit>

      <!-- <div class="newsletter__agree">
        <UiRichtext :html="$t('By subscribing you accept our terms & conditions')" />
      </div> -->
      </template>

      <p
        v-else
        class="newsletter__feedback"
      >
        {{ layoutData?.newsletter?.Feedback || $t('Thank you very much! You will receive an email from us within a few minutes.') }}
      </p>
    </div>
</FormKitLazyProvider>


    <!-- <pre>layoutData: {{ layoutData.newsletter }}</pre> -->
  </div>
</template>

<style>
@import url("~layers/components/Form/Newsletter.css");
</style>
